/**
 * Identity API client — the four calls the Admin Panel shell needs
 * (identity.yaml: loginWithPassword, refreshToken, logout, getMe).
 * Password login is the admin path; every mobile app uses OTP (ADR-008).
 */

import { apiRequest } from "../api/http";
import type { Transport } from "../api/transport";
import type { AuthResult, Me, TokenPair } from "./contract";

export interface LoginInput {
  readonly phone: string;
  readonly password: string;
  readonly deviceName?: string;
}

export function login(transport: Transport, input: LoginInput): Promise<AuthResult> {
  return apiRequest<AuthResult>(transport, {
    method: "POST",
    path: "/auth/login",
    body: {
      phone: input.phone,
      password: input.password,
      client_type: "ADMIN_WEB",
      ...(input.deviceName !== undefined ? { device_name: input.deviceName } : {}),
    },
  });
}

/**
 * identity.yaml v1.1.0 ADMIN_WEB flow: the body carries NO refresh token —
 * the server reads the httpOnly cookie (the fetch transport already sends
 * `credentials: "include"`); the mock emulates the same cookie internally.
 */
export function refreshTokens(transport: Transport): Promise<TokenPair> {
  return apiRequest<TokenPair>(transport, {
    method: "POST",
    path: "/auth/token/refresh",
    body: {},
  });
}

export function logout(transport: Transport, accessToken: string): Promise<null> {
  return apiRequest<null>(transport, {
    method: "POST",
    path: "/auth/logout",
    accessToken,
  });
}

export function getMe(transport: Transport, accessToken: string): Promise<Me> {
  return apiRequest<Me>(transport, {
    method: "GET",
    path: "/me",
    accessToken,
  });
}
